import React, { useMemo } from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import SaveIcon from '@mui/icons-material/Save';

import { hasTrussDesignPermission } from '@paragon/login-tools';

import { useAppMonitor } from '../../../monitor';
import { deleteNewestUserDimension, saveUserDimensions } from '../../../store/actions/localUserDimensions';
import { getUserDistanceDimensions } from '../../../store/selectors/getUserDistanceDimensions';
import { inViewOnlyMode } from '../../../store/selectors/viewOnlyModeSelectors';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { ToolbarIconButton } from './ToolbarIconButton';

export function DimensionModeToolbarButtons() {
  const monitor = useAppMonitor();
  const dispatch = useAppDispatch();

  const localUserDimensions = useAppSelector((state) => state.localUserDimensions);
  const areLocalChanges = useMemo(() => Object.values(localUserDimensions).length > 0, [localUserDimensions]);
  const userDistanceDimensions = useAppSelector(getUserDistanceDimensions);
  const isTrussDesigner = useAppSelector(hasTrussDesignPermission);
  const isViewOnlyComponent = useAppSelector(inViewOnlyMode);

  if (isViewOnlyComponent || !isTrussDesigner) return null;

  return (
    <>
      <ToolbarIconButton
        icon={<SaveIcon />}
        title="Save user dimensions"
        onClick={() => {
          dispatch(saveUserDimensions());
          monitor.recordInteraction('"Save User Dimensions" button clicked');
        }}
        disabled={!areLocalChanges}
      />

      <ToolbarIconButton
        icon={<DeleteIcon />}
        title="Delete newest user dimension"
        onClick={() => {
          dispatch(deleteNewestUserDimension());
          monitor.recordInteraction('"Delete Newest User Dimension" button clicked');
        }}
        disabled={userDistanceDimensions.length === 0}
      />
    </>
  );
}
